/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import clsx from 'clsx';
import React from 'react';
import { FormFieldProps, formFieldPropsDefaults } from './FormField.props';
import { FORM_FIELD_LABEL_POSITION_LEFT } from './FormField.types';

/**
 * SDS base Form Field component.
 */
export const FormField = (props: FormFieldProps): JSX.Element => {
  const { children, classes, errorMessage, fieldLabel, hideLabel, id, labelPosition, note, required } = {
    ...formFieldPropsDefaults,
    ...props,
  };

  const requiredText = `This field is required.`;
  const requiredIndicator = `*`;
  const inputClass = classes;

  const fieldClass = clsx(`sds-form-field`, {
    ['sds-form-field--inline']: labelPosition === FORM_FIELD_LABEL_POSITION_LEFT,
  });
  const labelClass = clsx(`sds-form-label`, {
    ['sds-form-label--visible']: !hideLabel,
  });

  return (
    <div className={fieldClass}>
      <div className={labelClass}>
        <label
          aria-hidden={hideLabel ? true : false}
          className={hideLabel ? `sr-only` : ``}
          htmlFor={id}
          id={`sds-form-label--${id}`}
        >
          {fieldLabel}
        </label>
        {required && !hideLabel && (
          <div className="sds-form-input__required">
            <span className="sr-only">{requiredText}</span>
            <span>{requiredIndicator}</span>
          </div>
        )}
      </div>
      <div className={inputClass}>{children}</div>
      {note && (
        <div className="sds-field-note">
          <span>{note}</span>
        </div>
      )}
      {errorMessage && (
        <div className="sds-field-error__message">
          <span>{errorMessage}</span>
        </div>
      )}
    </div>
  );
};
